export const setMessageToReactNative = (data: any) => {
  window?.ReactNativeWebView?.postMessage(data);
};
